import { render, staticRenderFns } from "./FooterElement.vue?vue&type=template&id=d223aad2&"
import script from "./FooterElement.vue?vue&type=script&lang=js&"
export * from "./FooterElement.vue?vue&type=script&lang=js&"
import style0 from "./FooterElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports